<template>
  <v-card
    style="border-top: #21a261 6px solid"
    class="mx-auto"
    tile
    @click="routeTo(species.url)"
  >
    <v-img
      class="white--text align-end click"
      max-height="200px"
      :src="$_getImage(species.li_image_id)"
      v-ripple
    >
    </v-img>

    <v-card-title>{{ species.name_sve }}</v-card-title>
    <!-- <v-card-subtitle class="pb-0">
      {{ species.name_lat }}
    </v-card-subtitle> -->
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Species',
  components: {},
  props: ['species'],

  methods: {
    $_getImage(imageId) {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/870/${imageId}.jpg`
    },
    routeTo(nameUrl) {
      this.$router.push({ name: 'SingleSpecies', params: { nameUrl: nameUrl } })
    }
  }
}
</script>

<style lang="css" scoped>
.click {
  cursor: pointer;
}
</style>
